package de.connect2x.tammy

import de.connect2x.trixnity.messenger.util.RootPath

internal actual fun getDevRootPath(): RootPath? = null
internal actual val platformDatabaseEncryptionEnabled: Boolean = false